import script from "./ListOrderedIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ListOrderedIcon.vue?vue&type=script&setup=true&lang=js"

export default script